<script lang="ts">
	let strokeColor = "black"
</script>

<svg
	width="79"
	height="42"
	viewBox="0 0 79 42"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class="svg-fill"
>
	<!-- <g clip-path="url(#clip0_102_2)"> -->
	<path
		d="M0 1.61803C0 0.874652 0.782312 0.391156 1.44721 0.723607L4.44721 2.22361C4.786 2.393 5 2.73926 5 3.11803V25C5 25.5523 4.55228 26 4 26H1C0.447715 26 0 25.5523 0 25V1.61803Z"
	/>
	<rect y="22" width="9" height="5" rx="1" />
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M74.5 6.00002H72.5498H67.0817H57.7183L48.3549 6L43.1503 6.00002H11.5C8.95017 6.00002 7 8.53005 7 11.838V19C7 19 11.5 20.5 11.5 21V28C11.5 28.5 7 30 7 30V36.1621C7 39.47 8.95017 42 11.5 42H15V18C15 17 19 17 19 18V42H21V18C21 17 25 17 25 18V42H27V18C27 17 31 17 31 18V42H38H62.6503H69.4003H74.5C77.0498 42 79 39.47 79 36.1621V11.838C79 8.7242 77.0498 6.00002 74.5 6.00002ZM46 30V34C46 35.1046 46.8954 36 48 36H71C72.1046 36 73 35.1046 73 34V30C73 28.8954 72.1046 28 71 28H48C46.8954 28 46 28.8954 46 30Z"
	/>
	<rect x="48" y="30" width="23" height="2" rx="1" />
	<!-- </g> -->
	<defs>
		<clipPath id="clip0_102_2">
			<rect width="79" height="42" />
		</clipPath>
	</defs>
</svg>

<style>
</style>
